
import Auth from '../api/auth/Auth';
import AgentSummary from '../components/agents/Summary.vue';
import GiftCertificateSummary from '../components/gift_certificates/GiftCertificateSummary.vue';
import TeeTimeSummary from '../components/tee_times/TeeTimeSummary.vue';

import Vue from 'vue';

Vue.component('agent-summary', AgentSummary);
Vue.component('gift-cert-summary', GiftCertificateSummary);
Vue.component('tee-time-summary', TeeTimeSummary);

export default Vue.extend({
  name: 'home',
  data() {
    return {
      selectedDate: '' as string,
      updateCounter: 0,
      selectDateMenu: false as boolean
    };
  },
  mounted() {
    this.setSelectedDate();
  },
  computed: {
    isAdmin() {
      return Auth.isAdmin();
    },
    selectedDateFormatted(): string | null {
      const selectedDate = this.$data.selectedDate as string;

      if (!selectedDate) {
        return null;
      }

      const [year, month, day] = selectedDate.split('-');

      return `${month}/${day}/${year}`;
    }
  },
  methods: {
    setSelectedDate(): void {
      const date = new Date();

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      this.selectedDate = `${year}-${month}-${day}`;
      this.refreshSummaries();
    },
    refreshSummaries() {
      this.updateCounter++;
    }
  },
});
